import { get, toString } from 'lodash';
import { getProfilePageParameters } from '../../state/selectors';
import { nextAvailabilitySelector } from './selector';
import { getLocationsCarouselState } from '../../../Shared/LocationCardCarousel/selectors';
import { INSURANCE_PICKER_KEY } from '@zocdoc/components/src/InsurancePicker';
import { newExistingRadioSelector } from '@zocdoc/components/src/newexistingradio/NewExistingRadioSelector';
import { procedureDropdownSelector } from '@zocdoc/components/src/ProcedureDropdown/ProcedureDropdownSelector';

export default function mapStateToProps(state) {
    const page = getProfilePageParameters(state);
    const newExistingRadioState = newExistingRadioSelector(state);
    const carouselState = getLocationsCarouselState(state);
    const insurancePickerState = state[INSURANCE_PICKER_KEY];
    const procedureDropdownState = procedureDropdownSelector(state);
    const nextAvailabilityState = nextAvailabilitySelector(state);

    const {
        defaultProcedureId,
        initParameters,
        referrerType,
        widget,
    } = page;

    const procedureId = initParameters && initParameters.procedureId === '-1' ?
        defaultProcedureId : toString(initParameters.procedureId);

    const props = {
        insuranceCarrier: get(insurancePickerState, 'carrier'),
        insurancePlan: get(insurancePickerState, 'plan'),
        isNewPatient: get(newExistingRadioState, 'isNewPatient', initParameters.isNewPatient),
        procedureId: get(procedureDropdownState, 'procedureId', procedureId),
        locationId: get(carouselState, 'locationId', initParameters.locationCloudId),
        nextAvailability: get(nextAvailabilityState, 'nextAvailability'),
        referrerType,
        widget,
    };

    return props;
}
